<template>
  <div class="flex flex-col gap-m items-start">
    <Skeleton class="h-[34px] w-[365px]" />
    <div class="flex flex-col xl:flex-row gap-m justify-start flex-wrap">
      <div v-for="n in 2" :key="n" class="w-[317px] rounded-4xl pt-xl px-l pb-l flex flex-col items-center gap-l bg-carbon-50">
        <Skeleton class="w-[116px] h-[163px] rounded-xl" />
        <div class="flex flex-col items-center gap-s w-full">
          <Skeleton class="h-5 w-3/4" />
          <Skeleton class="h-4 w-1/2" />
        </div>
      </div>
    </div>
  </div>
</template>
